import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import App from './App';


Sentry.init({
  dsn: window.dsn,
  integrations: [new Integrations.BrowserTracing()],
  environment: window.env,
  tracesSampleRate: 1.0,
});

ReactDOM.render(

  <React.StrictMode>
    <App />
  </React.StrictMode>
  ,
  document.getElementById('root')
);